const tag = document.createElement('script')
tag.src = "https://www.youtube.com/iframe_api"
const firstScriptTag = document.getElementsByTagName('script')[0]
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)

var player = null;
window.onYouTubeIframeAPIReady = function(){
  player = new YT.Player('youtube_player', {
    videoId: '_wRZJNt109k',
    playerVars: {
      //'autoplay': 1,
      //'mute': 1,
      'controls': 0,
      //'loop': 1,
      'playlist': '_wRZJNt109k',
      'rel': 0,
      'showinfo': 0,
      'modestbranding': 1,
    },
    events: {
      'onReady': onPlayerReady,
      'onStateChange': onPlayerStateChange
    }
  });
}

var onPlayerReady = function(event){
  event.target.setVolume(0);
  event.target.mute();
  event.target.playVideo();
};

var onPlayerStateChange = function(event){
  if(event.data == YT.PlayerState.ENDED){
    event.target.seekTo(0);
    event.target.playVideo();
  }
};

var Init = function(){
  var $window = $(window);
  var $body = $("body");
  var $header = $("header");
  var $logo = $("#logo");
  var $scroll = $("#scroll");
  var $sections = $(".section");

  $.scrollify({
    section : ".section",
    updateHash: false,
    offset: 0,
    scrollSpeed: 1500,
    setHeights: false,
    standardScrollElements: ".bottom",
    interstitialSection : "",
    before:function(index, $elements) {
      _c_("before, index: " + index);

      $sections.removeClass("current");
      $.scrollify.current().addClass("current");


      if($.scrollify.current().hasClass("is-content")){
        AnimationStart($.scrollify.current());
      }else{
        if($.scrollify.isDisabled()){$.scrollify.enable();}
      }

      $sections.not(".current").each(function(){
        ResetAnimate($(this));
      });

      if($.scrollify.currentIndex() < 12){
        $(".section13 .visual").css({opacity: ""});
      }else{
        $(".section13 .visual").css({opacity: 1});
      }

      if(index !== 0){
        $logo.addClass("change");
      }else{
        $logo.removeClass("change");
      }
    },
    after: function(index,$elements){
      _c_("after, index: " + index);
    },
    afterResize:function() {
      _c_("afterResize");
      ScrollifyPosAdjuster();
    },
    afterRender:function() {
      _c_("afterRender");

      $(".section").removeClass("current");
      $.scrollify.current().addClass("current");

      if($.scrollify.currentIndex() !== 0){
        $logo.addClass("change");
      }
      NavColorChange();
      if($.scrollify.current().hasClass("is-content")){
        AnimationStart($.scrollify.current());
      }
    }
  });

  $scroll.on("click", function(){
    $.scrollify.next();
  });


  $body.on("navopen", function(){
    if(!$.scrollify.isDisabled()){$.scrollify.disable();}
  });
  $body.on("navclose", function(){
    if($.scrollify.isDisabled()){$.scrollify.enable();}
  });

  $(".top-anchor").on("click", function(event){
    if($body.hasClass("nav--open")){
      NavOpenClose();
    }
    var _hash = $(event.currentTarget).attr("href");
    $.scrollify.move(_hash);
    return false;
  });

  var AddZero = function(n){
    var _n = "";
    if(n < 10){
      _n = "0" + n.toString();
    }
    return _n;
  };

  var ScrollifyPosAdjuster = function(){
    if(!$.scrollify.current().hasClass("section13")){
      var _adjustPos = $(".section" + ($.scrollify.currentIndex() + 1)).offset().top;
      $window.scrollTop(_adjustPos);
    }
  };

  var movieAspect = 16 / 9;
  var youtubeWrap = $("#youtube_wrap");
  var AspectCheck = function(){
    var _windowAspect = $window.outerWidth() / $window.outerHeight();

    if(_windowAspect > movieAspect){
      youtubeWrap.addClass("wider");
    }else{
      youtubeWrap.removeClass("wider");
    }
  };


  var Resize = function(){
    //_c_("Resize");
    if($window.width() > 829){
    }else{
    }
    AspectCheck();
  };
  $window.on("resize", Resize);
  Resize();

  $window.on("scroll", function(){
    if($.scrollify.isDisabled()){
      _c_("isDisabled");
      //$.scrollify.enable();
    }
  });
};

window.addEventListener("load", Init);
